import { address, addressValidators, } from '@/components/my-account/address-form/Address';
import { required, numeric, email } from 'vuelidate/lib/validators';
const { isDefault, ...reducedAddress } = address;
export const shippingDetailsForm = {
    ...reducedAddress,
    countryUuid: '',
    isDefault: false,
};
export const defaultCustomerData = {
    name: '',
    email: '',
    phone: '',
    phoneCountryUuid: '',
    emailConfirmed: false,
};
export const customerDataFormValidators = {
    email: {
        email,
        required,
    },
    name: {
        required,
    },
    phone: {
        required,
        numeric,
    },
    phoneCountryUuid: {
        required,
    },
    emailConfirmed: {
        required: (value) => value === true,
    },
};
export const shippingDetailsFormValidators = {
    ...addressValidators,
};
export function mapShippingFormToView({ street, buildingNumber, unitNumber, postcode, countryUuid, name, buildingName, city, }, countries) {
    let country = countries.find((country) => country.uuid === countryUuid);
    return {
        name: name ?? '',
        street: street ?? '',
        buildingNumber: buildingNumber ?? '',
        buildingName: buildingName ?? '',
        unitNumber: unitNumber ?? '',
        postcode: postcode ?? '',
        country: country ? country.name : '',
        city: city ?? '',
    };
}
